import type { SVGProps } from 'react';

export const CreditCardIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.667 10.667V16.333C22.667 18.3557 21.0227 20 19 20H5C2.97733 20 1.33301 18.3557 1.33301 16.333V10.667H22.667ZM5.66699 14C5.11499 14 4.66699 14.448 4.66699 15C4.66699 15.552 5.11499 16 5.66699 16H9.66699C10.2188 15.9998 10.667 15.5519 10.667 15C10.667 14.4481 10.2188 14.0002 9.66699 14H5.66699ZM17 14C16.448 14 16 14.448 16 15C16 15.552 16.448 16 17 16H18.333C18.885 16 19.333 15.552 19.333 15C19.333 14.448 18.885 14 18.333 14H17ZM19 4C21.0227 4 22.667 5.64433 22.667 7.66699V8.66699H1.33301V7.66699C1.33301 5.64433 2.97733 4 5 4H19Z"
      fill="currentColor"
    />
  </svg>
);
